/**
  * 商品规格 接口的统一出口
  */
 import axios from '.././http'; // 导入http中创建的axios实例
 import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


 // 接口请求地址
 const api = '/c-api/';

 const goodspec = {
     // 列表
     list (params) {
         return axios.get(api + 'goodspec/list',{params:params})
     },
     //添加
     create (params) {
         return axios.post(api + 'goodspec/create',qs.stringify(params))
     },
     //编辑
     edit (params) {
        return axios.post(api + 'goodspec/edit',qs.stringify(params))
    },
     //详情
     detail (params) {
         return axios.get(api + 'goodspec/detail',{params:params})
     },
     //删除
     remove (params) {
         return axios.post(api + 'goodspec/remove',qs.stringify(params))
     },
     // 规格详情
     specDetail (params) {
         return axios.get(api + 'goodspec/specDetail',{params:params})
     },
 }


 // 导出接口
 export default goodspec
